import React, { useState, useEffect, useRef } from 'react';
import { getCustomer, focusInput } from '../../../utils/helpers';
import { useDispatch, useSelector } from 'react-redux';

import { useNavigate, useLocation } from 'react-router-dom';

import { saveNewPassword, resetForgotPassword, forgotPassword } from "../../../store/actions";

import Loader from '../../../assets/components/loader';

const ResetPassword = () => {

  const customerId = getCustomer();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const resetPasswordInfo = useSelector((state) => state.resetPassword);

  const [userId, setUserId] = useState();
  const [tenantId, setTenantId] = useState();
  const [user, setUser] = useState({
    code: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    password: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    password1: {
      value: "",
      focused: false,
      required: true,
      error: ""
    }
  })

  useEffect(() => {
    dispatch(resetForgotPassword())
    if (customerId !== "") {
      navigate('/mySubscriptions');
    }else if (resetPasswordInfo.userId !== null){
      setUserId(resetPasswordInfo.userId)
      //navigate('/forgot-password');
    }
  }, [])

  useEffect(() => {
    const u = new URLSearchParams(location.search);
    if (u.size > 0) {
      const userIdParam = u.get('u');
      const tenantIdParam = u.get('t');
      setUserId(userIdParam.replace("b'", "").replace("'", ""));
      setTenantId(tenantIdParam);

      navigate({
        pathname: location.pathname,
        search: '',
      });
    }
  }, [location])

  useEffect(() => {
    if (resetPasswordInfo.redirect){
      navigate('/');
    }
  }, [resetPasswordInfo.redirect])

  const handleInputChange = (ev) => {
    setUser(prevUser => ({
      ...prevUser,
      [ev.target.name]: {
        ...prevUser[ev.target.name],
        value: ev.target.value,
        focused: true,
        error: prevUser[ev.target.name].required ? validate(ev.target.name, ev.target.value) : ""
      }
    }))
  }

  const handleOnfocus = (ev) => {
    setUser(prevUser => ({
      ...prevUser,
      [ev.target.name]: {
        ...prevUser[ev.target.name],
        focused: true,
        error: prevUser[ev.target.name].required ? validate(ev.target.name, ev.target.value) : ""
      }
    }))
  }

  const validate = (name, value) => {
    switch (name) {
      case("code"):
        if (value === "") {
          return "This field is required"
        }else{
          return ""
        }
        break;
      case("password"):
        if (value.length < 12){
          return "Password must be longer"
        } else if (!value.match(/[A-Z]/g)){
          return "Password must contain at least one uppercase character<"
        } else if (!value.match(/[^\w\s]/g)){
          return "Password must contain at least one special character"
        } else if (!value.match(/[0-9]/g)){
          return "Password must contain at least one number"
        } else if (value === "") {
          return "This field is required"
        } else{
          return ""
        }
        break;
      case("password1"):
        if (value !== user.password.value){
          return "Passwords does not match"
        }else if (value === ""){
          return "This field is required"
        }else{
          return ""
        }
        break;
      default:
        return ""

    }
  }

  const disabledSubmit = () => {
    if (resetPasswordInfo.loading) {
      return true
    }
    let keys = Object.keys(user)
    for (let i = 0; i < keys.length; i++) {
      if (user[keys[i]].required) {
        if (user[keys[i]].focused && user[keys[i]].error !== "") {
          return true
        } else if (!user[keys[i]].focused) {
          return true
        }
      }
    }
    return false
  }

  const handleSubmit = (ev) => {
    ev.preventDefault()
    dispatch(saveNewPassword({
      confirmation_code: user.code.value,
      username: userId,
      tenant: tenantId,
      new_password: user.password.value,
      new_password_1: user.password1.value,
    }))
  }

  return (
    <>
      <div className='reset-password'>
        <form className='marquet--form' onSubmit={ev => handleSubmit(ev)}>
          <div className='marquet--form--group'>
            <div onClick={ev => focusInput(ev)} className={user.code.focused === true ?
              user.code.error === "" ? "input--group input--success" : "input--group input--error" : "input--group"}>
              <label>Confirmation Code</label>
              <input
                name="code"
                type="text"
                autoComplete='off'
                maxLength={30}
                onChange={ev => handleInputChange(ev)}
                onFocus={ev => handleOnfocus(ev)}
                value={user.code.value}/>
            </div>
            <div className="invalid--feedback">{user.code.error}</div>
          </div>
          <div className='marquet--form--group'>
            <div onClick={ev => focusInput(ev)} className={user.password.focused === true ?
              user.password.error === "" ? "input--group input--success" : "input--group input--error" : "input--group"}>
              <label>Password</label>
              <input
                name="password"
                type="password"
                autoComplete='off'
                maxLength={30}
                onChange={ev => handleInputChange(ev)}
                onFocus={ev => handleOnfocus(ev)}
                value={user.password.value} />
            </div>
            <div className="invalid--feedback">{user.password.error}</div>
          </div>
          <div className='marquet--form--group'>
            <div onClick={ev => focusInput(ev)} className={user.password1.focused === true ?
              user.password1.error === "" ? "input--group input--success" : "input--group input--error" : "input--group"}>
              <label>Verify Password</label>
              <input
                name="password1"
                type="password"
                autoComplete='off'
                maxLength={30}
                onChange={ev => handleInputChange(ev)}
                onFocus={ev => handleOnfocus(ev)}
                value={user.password1.value} />
            </div>
            <div className="invalid--feedback">{user.password1.error}</div>
          </div>
          <div className="form-input">
            <div className="password-steps">
              <div className="pass-description">
                <p>
                  For your security your password must be at least 12 characters long,
                  contain at least 1 number, 1 uppercase letter and one special character.
                </p>
              </div>
              <div className="pass-features">
                <div className="pass-lock">
                  <svg width="33" height="36" viewBox="0 0 33 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.4541 0.770021C14.3292 0.644882 14.181 0.545598 14.0177 0.477856C13.8545 0.410113 13.6794 0.375244 13.5027 0.375244C13.3259 0.375244 13.1509 0.410113 12.9877 0.477856C12.8244 0.545598 12.6761 0.644882 12.5513 0.770021C9.21075 4.10521 5.51813 5.74996 1.40625 5.74996C1.04987 5.74996 0.708078 5.89153 0.456076 6.14353C0.204074 6.39554 0.0625 6.73732 0.0625 7.09371V15.1589C0.0625 23.0145 3.70138 28.5856 10.8125 31.6897V21.875C10.8122 20.6831 11.208 19.525 11.9378 18.5826C12.6675 17.6403 13.6897 16.9672 14.8438 16.6693V16.5C14.8433 15.0845 15.2155 13.6938 15.923 12.4678C16.6304 11.2418 17.6482 10.2237 18.8739 9.51577C20.0997 8.80784 21.4902 8.43509 22.9056 8.43498C24.3211 8.43487 25.7117 8.80741 26.9375 9.51515V7.09371C26.9375 6.73732 26.7959 6.39554 26.5439 6.14353C26.2919 5.89153 25.9501 5.74996 25.5938 5.74996C21.4792 5.74996 17.7866 4.11058 14.4541 0.770021ZM17.5312 19.1875V16.5C17.5312 15.0744 18.0975 13.7073 19.1056 12.6993C20.1136 11.6913 21.4807 11.125 22.9062 11.125C24.3318 11.125 25.6989 11.6913 26.7069 12.6993C27.715 13.7073 28.2812 15.0744 28.2812 16.5V19.1875H29.625C30.3378 19.1875 31.0213 19.4706 31.5253 19.9746C32.0294 20.4786 32.3125 21.1622 32.3125 21.875V32.625C32.3125 33.3377 32.0294 34.0213 31.5253 34.5253C31.0213 35.0293 30.3378 35.3125 29.625 35.3125H16.1875C15.4747 35.3125 14.7912 35.0293 14.2872 34.5253C13.7831 34.0213 13.5 33.3377 13.5 32.625V21.875C13.5 21.1622 13.7831 20.4786 14.2872 19.9746C14.7912 19.4706 15.4747 19.1875 16.1875 19.1875H17.5312ZM20.2188 16.5V19.1875H25.5938V16.5C25.5938 15.7872 25.3106 15.1036 24.8066 14.5996C24.3026 14.0956 23.619 13.8125 22.9062 13.8125C22.1935 13.8125 21.5099 14.0956 21.0059 14.5996C20.5019 15.1036 20.2188 15.7872 20.2188 16.5ZM24.9219 27.25C24.9219 26.7154 24.7095 26.2027 24.3315 25.8247C23.9535 25.4467 23.4408 25.2343 22.9062 25.2343C22.3717 25.2343 21.859 25.4467 21.481 25.8247C21.103 26.2027 20.8906 26.7154 20.8906 27.25C20.8906 27.7845 21.103 28.2972 21.481 28.6752C21.859 29.0532 22.3717 29.2656 22.9062 29.2656C23.4408 29.2656 23.9535 29.0532 24.3315 28.6752C24.7095 28.2972 24.9219 27.7845 24.9219 27.25Z" fill="#545454" />
                  </svg>
                </div>
                <div className="pass-list">
                  <ul>
                    <li>
                      <div>
                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.86643 10C4.75259 9.99963 4.64003 9.97586 4.53576 9.93015C4.43149 9.88444 4.33773 9.81778 4.26032 9.7343L0.225063 5.44166C0.0742197 5.28091 -0.00658653 5.06682 0.000420476 4.84648C0.00742748 4.62615 0.101674 4.41763 0.262426 4.26679C0.423179 4.11594 0.63727 4.03514 0.857601 4.04214C1.07793 4.04915 1.28646 4.1434 1.4373 4.30415L4.85813 7.94916L11.8409 0.310412C11.9118 0.22217 12 0.149346 12.1 0.0964136C12.2 0.043481 12.3098 0.0115572 12.4226 0.00260293C12.5355 -0.0063513 12.6489 0.00785317 12.756 0.0443437C12.8632 0.0808342 12.9617 0.13884 13.0456 0.2148C13.1295 0.290759 13.197 0.383067 13.2439 0.486056C13.2908 0.589044 13.3162 0.700538 13.3185 0.813688C13.3207 0.926839 13.2998 1.03926 13.2571 1.14404C13.2143 1.24882 13.1506 1.34376 13.0698 1.42301L5.48085 9.726C5.40417 9.81099 5.31074 9.8792 5.20643 9.92635C5.10213 9.9735 4.9892 9.99858 4.87474 10H4.86643Z" fill={user.password.value.length >= 12 ? "#3e884f" : "#B5B2B2"} />
                        </svg>
                        <span>At least 12 characters long</span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.86643 10C4.75259 9.99963 4.64003 9.97586 4.53576 9.93015C4.43149 9.88444 4.33773 9.81778 4.26032 9.7343L0.225063 5.44166C0.0742197 5.28091 -0.00658653 5.06682 0.000420476 4.84648C0.00742748 4.62615 0.101674 4.41763 0.262426 4.26679C0.423179 4.11594 0.63727 4.03514 0.857601 4.04214C1.07793 4.04915 1.28646 4.1434 1.4373 4.30415L4.85813 7.94916L11.8409 0.310412C11.9118 0.22217 12 0.149346 12.1 0.0964136C12.2 0.043481 12.3098 0.0115572 12.4226 0.00260293C12.5355 -0.0063513 12.6489 0.00785317 12.756 0.0443437C12.8632 0.0808342 12.9617 0.13884 13.0456 0.2148C13.1295 0.290759 13.197 0.383067 13.2439 0.486056C13.2908 0.589044 13.3162 0.700538 13.3185 0.813688C13.3207 0.926839 13.2998 1.03926 13.2571 1.14404C13.2143 1.24882 13.1506 1.34376 13.0698 1.42301L5.48085 9.726C5.40417 9.81099 5.31074 9.8792 5.20643 9.92635C5.10213 9.9735 4.9892 9.99858 4.87474 10H4.86643Z" fill={user.password.value.match(/[A-Z]/g) ? "#3e884f" : "#B5B2B2"} />
                        </svg>
                        <span>Must contain at least one uppercase character</span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.86643 10C4.75259 9.99963 4.64003 9.97586 4.53576 9.93015C4.43149 9.88444 4.33773 9.81778 4.26032 9.7343L0.225063 5.44166C0.0742197 5.28091 -0.00658653 5.06682 0.000420476 4.84648C0.00742748 4.62615 0.101674 4.41763 0.262426 4.26679C0.423179 4.11594 0.63727 4.03514 0.857601 4.04214C1.07793 4.04915 1.28646 4.1434 1.4373 4.30415L4.85813 7.94916L11.8409 0.310412C11.9118 0.22217 12 0.149346 12.1 0.0964136C12.2 0.043481 12.3098 0.0115572 12.4226 0.00260293C12.5355 -0.0063513 12.6489 0.00785317 12.756 0.0443437C12.8632 0.0808342 12.9617 0.13884 13.0456 0.2148C13.1295 0.290759 13.197 0.383067 13.2439 0.486056C13.2908 0.589044 13.3162 0.700538 13.3185 0.813688C13.3207 0.926839 13.2998 1.03926 13.2571 1.14404C13.2143 1.24882 13.1506 1.34376 13.0698 1.42301L5.48085 9.726C5.40417 9.81099 5.31074 9.8792 5.20643 9.92635C5.10213 9.9735 4.9892 9.99858 4.87474 10H4.86643Z" fill={user.password.value.match(/[^\w\s]/g) ? "#3e884f" : "#B5B2B2"} />
                        </svg>
                        <span>Must contain at least one special character</span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.86643 10C4.75259 9.99963 4.64003 9.97586 4.53576 9.93015C4.43149 9.88444 4.33773 9.81778 4.26032 9.7343L0.225063 5.44166C0.0742197 5.28091 -0.00658653 5.06682 0.000420476 4.84648C0.00742748 4.62615 0.101674 4.41763 0.262426 4.26679C0.423179 4.11594 0.63727 4.03514 0.857601 4.04214C1.07793 4.04915 1.28646 4.1434 1.4373 4.30415L4.85813 7.94916L11.8409 0.310412C11.9118 0.22217 12 0.149346 12.1 0.0964136C12.2 0.043481 12.3098 0.0115572 12.4226 0.00260293C12.5355 -0.0063513 12.6489 0.00785317 12.756 0.0443437C12.8632 0.0808342 12.9617 0.13884 13.0456 0.2148C13.1295 0.290759 13.197 0.383067 13.2439 0.486056C13.2908 0.589044 13.3162 0.700538 13.3185 0.813688C13.3207 0.926839 13.2998 1.03926 13.2571 1.14404C13.2143 1.24882 13.1506 1.34376 13.0698 1.42301L5.48085 9.726C5.40417 9.81099 5.31074 9.8792 5.20643 9.92635C5.10213 9.9735 4.9892 9.99858 4.87474 10H4.86643Z" fill={user.password.value.match(/[0-9]/g) ? "#3e884f" : "#B5B2B2"} />
                        </svg>
                        <span>Must contain at least one number</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="marquet--button--group">
            {/*<button
              className="custom--button"
              disabled={resetPasswordInfo.loadingReset}
              onClick={ev => { dispatch(forgotPassword({username:userId}))}}
              type='button'>
              Reset password
              {resetPasswordInfo.loadingReset && <Loader size="xs" />}
            </button>*/}
            <button
              className="custom--button"
              disabled={disabledSubmit()}
              type='submit'>
              Reset password
              {resetPasswordInfo.loading && <Loader size="xs" />}
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export default ResetPassword;